"use client";
import Image from 'next/image';
import { StaticImageData } from 'next/image';

interface pointInterface {
  num: string;
  title: string;
  text: string;
  img: string | StaticImageData;
  layout?: 'left' | 'right' | undefined;
  alt?: string;
}

export default function Point ({ num, title, text, img, layout, alt }: pointInterface) {
  return (
    <div className={`flex flex-row ${layout === 'right' ? 'flex-row-reverse' : ''} sm:!flex-row-reverse`}>
      <div className="w-[41.666%] flex flex-row sm:flex-col sm:w-full sm:pl-6 sm:pb-[60px]">
        <div className="w-[20%] sm:w-full">
          <p className="h1 !font-normal">{num}</p>
        </div>
        <div className="w-[80%] flex flex-col gap-[32px] sm:gap-6 sm:w-full">
          <h3 className="h1 !font-normal">{title}</h3>
          <Image
            src={img}
            width={typeof img === 'object' ? img.width : 960}
            height={480}
            className='w-full h-auto object-cover rounded-[10px]'
            alt={alt ?? title}
            onContextMenu={(e) => e.preventDefault()}
          />
          <p className="h2 !font-normal" dangerouslySetInnerHTML={{ __html: text }}></p>
        </div>
      </div>

      <div className="w-[16.666%] relative sm:w-[24px]">
        <div className="absolute bg-black left-[50%] top-0 translate-x-[-50%] rounded-full w-[18px] h-[18px]"></div>
        {num != "05" && <div className="absolute bg-black left-[50%] top-[9px] translate-x-[-50%] w-[2px] h-full"></div>}
      </div>
    </div>
  );
}
    


export function TextPoint ({ num, title }: Omit<pointInterface, 'img' | 'layout' | 'text'>) {
  return (
    <div className="flex flex-row">

      {/* <div className="w-[16.666%] relative sm:w-[24px]">
        <div className="absolute bg-black left-[50%] top-0 translate-x-[-50%] rounded-full w-[18px] h-[18px]"></div>
        {num != "04" && <div className="absolute bg-black left-[50%] top-[9px] translate-x-[-50%] w-[2px] h-full"></div>}
      </div> */}

      <div className="w-[83.333%] pb-[192px] sm:pb-[60px] sm:w-full sm:pl-6">
        <p className="h3 inline-block mr-2 translate-y-[-.6em] !font-normal">{num} </p>
        <h3 className="h1 inline !font-normal sm:!text-[24px]"> {title}</h3>
      </div>
    </div>
  );
}